import { setupWorker } from "msw/browser";

import { handlers } from "./handlers";

export const worker = setupWorker(...handlers);

/**
 * Boot the MSW service worker. No-op outside the browser or when
 * VITE_API_MODE is not "mock" (real mode goes through the /api dev proxy).
 * Await this before mounting the app so the first queries are intercepted.
 */
export async function enableMocking(): Promise<void> {
  if (typeof window === "undefined") return;
  if (import.meta.env.VITE_API_MODE !== "mock") return;
  await worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: { url: "/mockServiceWorker.js" },
  });
}
